<template>
    <span class="adminUserDisplay">
        <span class="userreal_name">{{companyname}} - {{storename}} - {{username}}</span>
       <!--{{user.real_name}-->
    </span>
</template>

<script>
    export default {
        name: 'AdminUserDisplay',
        data() {
            return {
                 user: {},
              companyname: "",
              storename: "",
              user_role: "",
              username: "",
            };
        },
      watch: {
        '$store.state.companyname': function (newVal, oldVal) {
          const modul = this;
          const companyname = (modul.$store.state && modul.$store.state.companyname) ? modul.$store.state.companyname : "";
          modul.companyname = companyname;
        },
        '$store.state.storename': function (newVal, oldVal) {
          const modul = this;
          const storename = (modul.$store.state && modul.$store.state.storename) ? modul.$store.state.storename : "";
          modul.storename = storename;
        },
        '$store.state.user': function (newVal, oldVal) {
          const modul = this;
          const user = (modul.$store.state && modul.$store.state.user ) ? modul.$store.state.user: {};
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          modul.role = role;
          modul.user = user;
          modul.username = (user.real_name)?user.real_name:"";
        },
      },
        mounted() {
            const modul = this;
            console.log("AdminUserDisplay");
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          modul.user_role = role;
          const user = (modul.$store.state && modul.$store.state.user ) ? modul.$store.state.user: {};
          modul.username = (user.real_name)?user.real_name:"";

          const companyname = (modul.$store.state && modul.$store.state.companyname) ? modul.$store.state.companyname : "";
          modul.companyname = companyname;
          const storename = (modul.$store.state && modul.$store.state.storename) ? modul.$store.state.storename : "";
          modul.storename = storename;

            modul.$eventBus.$on('globalAdminuserChange', this.globalAdminuserChangeEventHandler);
//            if(window.user){
//                modul.user=window.user;
//            }
        },
        beforeDestroy() {
            this.$eventBus.$off('globalReadElement');
        },
        methods: {
            globalAdminuserChangeEventHandler(user){
                const modul = this;
                modul.user = user
            },
        },
        components: {
        },
    };
</script>
<style scoped>
    .userreal_name {
        font-size: 14px;
        line-height: 12px;
    }
    .adminUserDisplayY {
        line-height: 10px;
    }
    .adminUserDisplayX {
        float: right;
        width: 100%;
        font-size: 9px;
        /*position: relative;*/
        /*top: 4px;*/
        position: absolute;
        top: 56px;
        right: 16px;
    }
</style>
